export default __webpack_public_path__ + "e88b4f86444e063076b43b645e348e79.png";